export default function getResource(label, vars = []) {
    const resources = {
        freeReturnsBannerPrefix: 'Gratuit',
        freeReturnsBannerSuffix: ' Retours en magasin ou en ligne dans un délai de 30 jours*',
        freeReturnsInfoAriaLabel: 'Détails de la politique de retour',

        freeShippingCardTitle: 'Expédition gratuite',
        fastDelivery: 'Livraison rapide',
        sameDayDelivery: 'Livraison le jour même',
        pickupCardTitle: 'Ramassage',

        pickupCardEta: 'Dès aujourd’hui',
        fastDeliveryCardEta: 'Dès aujourd’hui',

        asSoonAsToday: 'Dès aujourd’hui',
        asSoonAsTomorrow: 'Dès demain',
        asSoonAs: `Dès ${vars[0]}`,

        availableInAllStoresCardTitle: 'Offert dans tous les magasins',
        onlineOnly: 'En ligne seulement',
        fastDeliveryNotAvailable: 'Non disponible pour cet article',
        fastDeliveryTemporarilyUnavailable: 'Temporarily unavailable',
        pickupNotAvailable: 'Non disponible pour le ramassage',

        for: 'pour',
        in: 'in',
        yourLocation: 'votre emplacement',
        inStock: 'En stock',
        outOfStock: 'Rupture de stock',
        limitedStock: 'Quantités limitées',
        selectForStoreAvailability: 'Sélectionner pour voir la disponibilité',
        notAvailable: 'Non disponible',
        fastDeliveryNotAvailableForZip: 'Livraison rapide non disponible',
        fastDeliveryPanelZipAriaLabel: `${vars[0]}, change delivery location`,
        fastDeliveryPanelInfoAriaLabel: 'À propos de la livraison rapide',

        sddRougeTestV2Message: `En tant que membre Rouge, vous êtes à ${vars[0]} de pouvoir profiter de la livraison le jour même GRATUITE.`,
        sddRougeTestV2FreeShippingMessage: 'En tant que membre Rouge, vous profitez de la livraison le jour même GRATUITE.',
        fastDeliveryRougeTestV2Message: `En tant que membre Rouge, vous êtes à ${vars[0]} de pouvoir profiter de la livraison rapide GRATUITE.`,
        fastDeliveryRougeTestV2FreeShippingMessage: 'En tant que membre Rouge, vous pouvez essayer la livraison rapide GRATUITE.',

        shippingPanelTo: 'à',
        shippingPanelZipAriaLabel: 'Modifier l’emplacement de livraison',
        shippingPanelInfoAriaLabel: 'Détails de la politique d’expédition et de retour',
        shippingPanelBiPrefix: 'Les membres Beauty Insider profitent de l’ ',
        shippingPanelBiSuffix: 'expédition standard GRATUITE',
        freeStandardShipping: 'Free standard shipping',

        // Pickup details panel (SHP-5238)
        storesNearYou: 'magasins près de chez vous',
        pickupPanelAt: 'à',
        pickupPanelChangeStoreAriaLabel: `${vars[0]}, modifier le magasin de ramassage`,
        pickupPanelInfoAriaLabel: 'Renseignements pour « Achetez en ligne, ramassez en magasin »',
        inStorePickup: 'Ramassage en magasin',
        curbsidePickup: 'Ramassage à l’extérieur',
        curbsideConcierge: 'Concierge pour ramassage à l’extérieur',

        // Signed-out state (SHP-5258)
        signInLinkLabel: 'Ouvrir une session',
        createAccountLinkLabel: 'créer un compte',
        freeShippingSignInCardText: `${vars[0]} pour`,
        freeShippingSignInAriaLabel: `${vars[0]} pour ${vars[1]}`,
        shippingPanelSignInPrompt: `${vars[0]} ou ${vars[1]} pour profiter de ${vars[2]}`,

        // Nearby store availability row (SHP-5280)
        nearbyStores: 'magasins à proximité',
        nearbyStoresLinkAriaLabel: 'Vérifier la disponibilité dans les magasins à proximité',

        // Auto-Replenish row
        autoReplenishRowSavePercent: `Enregistrer ${vars[0]}`,
        autoReplenishRowSuffix: ' avec le réapprovisionnement automatique',
        autoReplenishRowCheckboxAriaLabel: `Économisez ${vars[0]} grâce au réapprovisionnement automatique`,

        autoReplenishRowSavePercentHotDeal: `Save ${vars[0]}*`,
        autoReplenishRowSuffixHotDeal: ' with Auto-Replenish Hot Deal',
        autoReplenishRowCheckboxAriaLabelHotDeal: `Save ${vars[0]} with Auto-Replenish Hot Deal`,

        deliveryEvery: 'Livrer chaque :',
        mostCommon: 'le plus courant',
        deliveryFrequencyLinkAriaLabel: 'Modifier la fréquence de livraison pour le réapprovisionnement automatique',
        autoReplenishRowNotEligible: 'Non admissible au réapprovisionnement automatique',
        autoReplenishLegalOptIn: 'En vous inscrivant, vous consentez aux frais récurrents de votre abonnement.',
        learnMore: 'En savoir plus',
        autoReplenishFirstTimeLegalShown: `*Les nouveaux abonnés obtiennent une réduction de ${vars[0]} sur leurs ${vars[1]} premières commandes, livrée dans les ${vars[2]} mois suivant la commande initiale. La période de promotion se termine le ${vars[3]}.`,
        autoReplenishFirstTimeLegalDetails: 'Détails',
        autoReplenishFirstTimeLegalMoreDetails: `Pour chaque produit en super aubaine, l’abonnement et le nombre d’unités sont limités à 1 par membre de la clientèle. Après ${vars[0]} commandes de réapprovisionnement à ${vars[1]} de réduction ou après ${vars[2]} mois à compter de la date d’inscription initiale, selon la première éventualité, l’abonnement est renouvelé à ${vars[3]} de réduction.`,

        fulfillmentMethodsGroupAriaLabel: 'Choisir une méthode d’expédition',
        outOfStockAt: `Out of Stock at ${vars[0]}`,
        outOfStockForZip: `Out of Stock for ${vars[0]}`,
        checkOtherStores: 'Check other stores',
        notAvailableInZip: `Not available in ${vars[0]}`,
        checkAnotherLocation: 'Check another location',

        checkNearbyStores: 'Check nearby stores',
        pickupNotOfferedAtStore: 'Pickup not offered at this store',
        pickupNotOfferedForItem: 'Pickup not offered for this item'
    };

    return resources[label];
}
